import React, { useState, useEffect } from 'react'
import {
  Text,
  withSitecoreContext,
  RichText,
  isEditorActive,
  Link
} from '@sitecore-jss/sitecore-jss-react'

import './index.scss'
import { DownloadListProps } from './types/DownloadList.types'
import { anchorWithId } from '../../helpers/anchorWithId.helper'

const convertFileSize = (sizeInBytes) => {
  if (sizeInBytes) {
    const fielSize = (sizeInBytes / (1024 * 1024)).toFixed(2)
    const fielSizeNumber = parseInt(fielSize)
    if (fielSizeNumber < 1) {
      return (sizeInBytes / 1024).toFixed(2) + ' ' + ' KB'
    } else return (sizeInBytes / (1024 * 1024)).toFixed(2) + ' ' + 'MB'
  }
}

const DownloadList = (props: DownloadListProps) => {
  const downloadListItems = props.fields?.Attachments
  const downloadListTitle = props.fields?.Title
  const loadMoreText = props.fields?.['Load More Text'];
  const numberOfDoc = parseInt(props.fields?.NumberOfAttachments?.value ?? '0')
  // const numberOfDoc = 3
  const [currentDocToShow, setloadMore] = useState<number>(0);

  React.useEffect(() => {
    setloadMore(numberOfDoc)
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  // navigazione sulla dx OptionalCTA

  // target rimpiazza con linktarget

  return (
    <>
      {props.fields && (
        <div className="rte-event" id={props?.rendering?.uid}>
          <Text
            field={downloadListTitle}
            className="rte-event-heading"
            tag="h2"
          />

          {downloadListItems?.slice(0, currentDocToShow)
            .map((item, index: number) => (
              <div
                key={index}
                className={
                  index % 2
                    ? 'rte-event-list rte-event-listBKB'
                    : 'rte-event-list rte-event-listBKA'
                }
                // className={'download__list__item'}
              >
                <div className="download__list__media">
                  <div className="rte-event-list-right">
                    <div className="rte-event-list-header-wrapper">
                      <div className="rte-event-list-header left">
                        {/* modify with field */}
                        {(item.fields?.Date?.value ||
                          item.fields?.Date?.value?.length !== 0) && (
                          <div className={`rte-event-list-heading-father`}>
                            <p className="rte-event-list-heading-left">
                              {item.fields?.Date?.value}
                            </p>
                          </div>
                        )}

                        <RichText
                          field={item.fields?.['Attachment Name']}
                          className="rte-event-list-heading rte-event-list-headingException"
                          tag="h3"
                        />
                      </div>
                      <div
                        className={`rte-event-list-header right rte-event-list-header rightException`}
                      >
                        {((item?.fields?.['Attachment Link']?.value?.src &&
                          item.fields['Attachment Link']?.value?.src?.length !==
                            0 &&
                          ((item.fields['Attachment Link']?.value?.extension &&
                            item.fields['Attachment Link']?.value?.extension
                              ?.length !== 0) ||
                            (item.fields?.['Attachment Icon']?.value?.src &&
                              item.fields?.['Attachment Icon']?.value?.src
                                ?.length !== 0))) ||
                          (item?.fields?.['Attachment Link Second']?.value?.src &&
                            item.fields['Attachment Link Second']?.value?.src
                              ?.length !== 0 &&
                            ((item.fields['Attachment Link Second']?.value
                              ?.extension &&
                              item.fields['Attachment Link Second']?.value
                                ?.extension?.length !== 0) ||
                              (item.fields?.['Attachment Icon Second']?.value
                                ?.src &&
                                item.fields?.['Attachment Icon Second']?.value
                                  ?.src?.length !== 0))) ||
                          (item?.fields?.['Attachment Link Third']?.value?.src &&
                            item.fields['Attachment Link Third']?.value?.src
                              ?.length !== 0 &&
                            ((item.fields['Attachment Link Third']?.value
                              ?.extension &&
                              item.fields['Attachment Link Third']?.value
                                ?.extension?.length !== 0) ||
                              (item.fields?.['Attachment Icon Third']?.value
                                ?.src &&
                                item.fields?.['Attachment Icon Third']?.value
                                  ?.src?.length !== 0)))) && (
                          <div className="rte-event-list-heading-grandfather">
                            {item.fields['Attachment Link']?.value?.src &&
                              item.fields['Attachment Link']?.value?.src
                                ?.length !== 0 && (
                                <div
                                  className={`rte-event-list-heading-father ${
                                    item.fields?.['Attachment Icon']?.value?.src
                                      ?.length !== 0 &&
                                    item.fields?.['Attachment Icon']?.value?.src
                                      ?.length !== undefined &&
                                    'rte-event-list-heading-father--icon'
                                  }`}
                                >
                                  <a
                                    className={`rte-event-list-heading-left rte-event-list-heading-left-black ${
                                      item.fields?.['Attachment Icon']?.value
                                        ?.src?.length !== 0 &&
                                      item.fields?.['Attachment Icon']?.value
                                        ?.src?.length !== undefined &&
                                      'rte-event-list-heading-left-black--icon'
                                    }`}
                                    href={anchorWithId(
                                      item.fields['Attachment Link']?.value
                                        ?.src,
                                      item.fields['Attachment Link']?.value
                                        .anchor
                                    )}
                                    target={
                                      item?.fields?.linktarget?.value &&
                                      item?.fields?.linktarget?.value !== ''
                                        ? item?.fields?.linktarget?.value
                                        : '_self'
                                    }
                                  >
                                    {item.fields?.['Attachment Icon']?.value
                                      ?.src?.length !== 0 &&
                                    item.fields?.['Attachment Icon']?.value?.src
                                      ?.length !== undefined ? (
                                      <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left rte-event-list-heading-left-black">
                                        <img
                                          loading="lazy"
                                          src={
                                            item.fields?.['Attachment Icon']
                                              ?.value?.src
                                          }
                                          alt={
                                            item.fields?.['Attachment Icon']
                                              ?.value?.alt as string
                                          }
                                          width="24"
                                          height="24"
                                          className="PFElement svgicon"
                                        />
                                      </span>
                                    ) : (
                                      <Text
                                        field={{
                                          value:
                                            item.fields[
                                              'Attachment Link'
                                            ]?.value?.extension.toUpperCase(),
                                        }}
                                        tag="p"
                                        className="rte-event-list-heading-left rte-event-list-heading-left-black"
                                      />
                                    )}
                                  </a>
                                  <p className="rte-event-list-heading-left item">
                                    {convertFileSize(
                                      item.fields['Attachment Link']?.value
                                        ?.size
                                    )}
                                  </p>
                                </div>
                              )}

                            {item.fields['Attachment Link Second']?.value
                              ?.src &&
                              item.fields['Attachment Link Second']?.value?.src
                                .length !== 0 && (
                                <div
                                  className={`rte-event-list-heading-father ${
                                    item.fields?.['Attachment Icon Second']
                                      ?.value?.src?.length !== 0 &&
                                    item.fields?.['Attachment Icon Second']
                                      ?.value?.src?.length !== undefined &&
                                    'rte-event-list-heading-father--icon'
                                  }`}
                                >
                                  <a
                                    className={`rte-event-list-heading-left rte-event-list-heading-left-black ${
                                      item.fields?.['Attachment Icon Second']
                                        ?.value?.src?.length !== 0 &&
                                      item.fields?.['Attachment Icon Second']
                                        ?.value?.src?.length !== undefined &&
                                      'rte-event-list-heading-left-black--icon'
                                    }`}
                                    href={anchorWithId(
                                      item.fields['Attachment Link Second']
                                        ?.value.src,
                                      item.fields['Attachment Link Second']
                                        ?.value.anchor
                                    )}
                                    target={
                                      item?.fields?.linktarget?.value &&
                                      item?.fields?.linktarget?.value !== ''
                                        ? item?.fields?.linktarget?.value
                                        : '_blank'
                                    }
                                  >
                                    {item.fields?.['Attachment Icon Second']
                                      ?.value?.src?.length !== 0 &&
                                    item.fields?.['Attachment Icon Second']
                                      ?.value?.src?.length !== undefined ? (
                                      <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left rte-event-list-heading-left-black">
                                        <img
                                          loading="lazy"
                                          src={
                                            item.fields?.[
                                              'Attachment Icon Second'
                                            ]?.value?.src
                                          }
                                          alt={
                                            item.fields?.[
                                              'Attachment Icon Second'
                                            ]?.value?.alt
                                          }
                                          width="24"
                                          height="24"
                                          className="PFElement svgicon"
                                        />
                                      </span>
                                    ) : (
                                      <Text
                                        field={{
                                          value:
                                            item.fields[
                                              'Attachment Link Second'
                                            ]?.value?.extension.toUpperCase(),
                                        }}
                                        tag="p"
                                        className="rte-event-list-heading-left rte-event-list-heading-left-black"
                                      />
                                    )}
                                  </a>
                                  <Text
                                    field={{
                                      value: convertFileSize(
                                        item.fields['Attachment Link Second']
                                          ?.value?.size
                                      ),
                                    }}
                                    tag="p"
                                    className="rte-event-list-heading-left item"
                                  />
                                </div>
                              )}

                            {item.fields['Attachment Link Third']?.value?.src &&
                              item.fields['Attachment Link Third']?.value?.src
                                .length !== 0 && (
                                <div
                                  className={`rte-event-list-heading-father ${
                                    item.fields?.['Attachment Icon Third']
                                      ?.value?.src?.length !== 0 &&
                                    item.fields?.['Attachment Icon Third']
                                      ?.value?.src?.length !== undefined &&
                                    'rte-event-list-heading-father--icon'
                                  }`}
                                >
                                  <a
                                    className={`rte-event-list-heading-left rte-event-list-heading-left-black ${
                                      item.fields?.['Attachment Icon Third']
                                        ?.value?.src?.length !== 0 &&
                                      item.fields?.['Attachment Icon Third']
                                        ?.value?.src?.length !== undefined &&
                                      'rte-event-list-heading-left-black--icon'
                                    }`}
                                    href={anchorWithId(
                                      item.fields['Attachment Link Third']
                                        ?.value.src,
                                      item.fields['Attachment Link Third']
                                        ?.value.anchor
                                    )}
                                    target={
                                      item?.fields?.linktarget?.value &&
                                      item?.fields?.linktarget?.value !== ''
                                        ? item?.fields?.linktarget?.value
                                        : '_blank'
                                    }
                                  >
                                    {item.fields?.['Attachment Icon Third']
                                      ?.value?.src?.length !== 0 &&
                                    item.fields?.['Attachment Icon Third']
                                      ?.value?.src?.length !== undefined ? (
                                      <span className="link-with-arrow link-with-arrow--text--event rte-event-list-heading-left rte-event-list-heading-left-black">
                                        <img
                                          loading="lazy"
                                          src={
                                            item.fields?.[
                                              'Attachment Icon Third'
                                            ]?.value?.src
                                          }
                                          alt={
                                            item.fields?.[
                                              'Attachment Icon Third'
                                            ]?.value?.alt
                                          }
                                          width="24"
                                          height="24"
                                          className="PFElement svgicon"
                                        />
                                      </span>
                                    ) : (
                                      <Text
                                        field={{
                                          value:
                                            item.fields[
                                              'Attachment Link Third'
                                            ]?.value?.extension.toUpperCase(),
                                        }}
                                        tag="p"
                                        className="rte-event-list-heading-left rte-event-list-heading-left-black"
                                      />
                                    )}
                                  </a>
                                  <Text
                                    field={{
                                      value: convertFileSize(
                                        item.fields['Attachment Link Third']
                                          ?.value?.size
                                      ),
                                    }}
                                    tag="p"
                                    className="rte-event-list-heading-left item"
                                  />
                                </div>
                              )}
                          </div>
                        )}

                        {item.fields?.OptionalCTA?.value?.href && (
                          <div className="file-info">
                            <div className="optional__CTA">
                              {isEditorActive() ? (
                                <Link
                                  field={item.fields?.OptionalCTA}
                                />
                              ) : (
                                <Link
                                  field={{
                                    value:
                                      item.fields?.OptionalCTA?.value?.href,
                                  }}
                                  href={anchorWithId(
                                    item.fields?.OptionalCTA?.value?.href,
                                    item.fields?.OptionalCTA?.value?.anchor
                                  )}
                                  target={
                                    item?.fields.OptionalCTA.value.linktype &&
                                    item?.fields.OptionalCTA.value.linktype !==
                                      ''
                                      ? item?.fields.OptionalCTA.value
                                          .linktype === 'internal'
                                        ? '_self'
                                        : item?.fields.OptionalCTA.value
                                            .linktype === 'external'
                                        ? '_blank'
                                        : item?.fields.OptionalCTA.value
                                            .linktype
                                      : '_blank'
                                  }
                                >
                                  <Text
                                    field={{
                                      value:
                                        item.fields?.OptionalCTA?.value?.title,
                                    }}
                                    tag="a"
                                  />
                                  <pfe-icon
                                    size={24}
                                    icon="cnh-arrow-forward"
                                  />
                                </Link>
                              )}
                            </div>

                            {/* {isEditorActive() ? (
                              <Link
                                field={item.fields?.['Attachment Link']}
                              />
                            ) : (
                              <></>
                            )} */}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          {currentDocToShow < (downloadListItems?.length ?? 0) ? (
            <div className="load-more">
              <button
                onClick={() => setloadMore(currentDocToShow + numberOfDoc)}
              >
                {isEditorActive() ? (
                  <Link field={loadMoreText as any} />
                ) : (
                  <>
                    <Text
                      field={{ value: loadMoreText?.value }}
                      tag="span"
                      className="load-more-text"
                    />
                    <pfe-icon icon="cnh-arrow-forward" size={24}></pfe-icon>
                  </>
                )}
              </button>
            </div>
          ) : null}
        </div>
      )}
    </>
  )
}

export default withSitecoreContext()(DownloadList)
